module.exports = __webpack_public_path__ + "static/media/service-02.aac73206.png";